var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.43707 3.37978C7.9684 3.37978 7.59768 3.45771 7.32386 3.61358C7.05003 3.77051 6.8752 3.96535 6.79726 4.20021C6.71827 4.43402 6.6793 4.73312 6.6793 5.09858V7.55882H10L9.53133 11.1133H6.6793V20.0591H3.0079V11.1133H0V7.55882H3.0079V4.74681C3.0079 3.26182 3.42496 2.10964 4.25803 1.2892C5.0911 0.468772 6.198 0.059082 7.57767 0.059082C8.69826 0.059082 9.60927 0.111741 10.3128 0.214953V3.37978H8.43812H8.43707Z","fill":"#3875FC"}));
}

Facebook.defaultProps = {"width":"11","height":"21","viewBox":"0 0 11 21","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
